// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mo-1";
export var messageSideRight = "_mo-2";
export var orderLookupBubbleContainer = "_mo-0";
export var submitButton = "_mo-3";